import VueGPicker from './VueGPicker'

export default VueGPicker
